import type { ReactNode } from 'react'

type Tone = 'green' | 'red' | 'amber' | 'blue' | 'slate'

// Dark-theme status pills — translucent fill + matching text/border, the
// same "colour on a low-opacity wash" treatment the marketing site uses.
const tones: Record<Tone, string> = {
  green: 'bg-green-500/10 text-green-400 border-green-500/25',
  red: 'bg-red-500/10 text-red-400 border-red-500/25',
  amber: 'bg-glow-500/10 text-glow-500 border-glow-500/30',
  blue: 'bg-blue-500/10 text-blue-400 border-blue-500/25',
  slate: 'bg-white/5 text-muted border-line',
}

// Badge — small status pill, used on the glow list and detail header
// for status (Lit/Dark), auth_mode (Public/Private), region, and the
// "Live" pill in the versions table.
export function Badge({ tone = 'slate', children }: { tone?: Tone; children: ReactNode }) {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium ${tones[tone]}`}
    >
      {children}
    </span>
  )
}
